import { StoreQueryKeys } from "store/store-query-keys";

export const generatePlansQueryKey = (cityName: string) => [
  StoreQueryKeys.PLANS,
  cityName,
];
